import $ from 'jquery';

export default () => {
  function setGalleryDisplayMedia($gallery, $resourceItem, $prev, $next) {
    let mediaSource = $resourceItem.find('.resource').first().attr('href');
    
    if ($resourceItem.hasClass('selected')) {
      $gallery.find('.gallery-content').first().addClass('selected');
    } else {
      $gallery.find('.gallery-content').first().removeClass('selected');
    }

    $gallery.find('#gallery-media')
      .attr('src', mediaSource)
      .data('media', $resourceItem.children('.media').first().attr('id'));
    $gallery.find('.media-download').first().attr('href', mediaSource);
    $gallery.find('.control.next').first().data('target', $next.length === 0 ? null : $next);
    $gallery.find('.control.prev').first().data('target', $prev.length === 0 ? null : $prev);
  }

  const $galleries = $('.gallery');

  $(document).on('click', '.gallery-caller', function(e) {
    e.preventDefault();

    const $clicked = $(this);
    const $resourceItem = $clicked.closest($clicked.data('parent'));

    setGalleryDisplayMedia(
      $($clicked.data('target')),
      $clicked.closest($clicked.data('parent')),
      $resourceItem.prev(),
      $resourceItem.next()
    );
  });

  $galleries.on('click', '.control', function(e) {
    e.preventDefault();

    const $clicked = $(this);
    const $target = $clicked.data('target'); // Next or prev media to show.

    if (!$target) {
      return;
    }

    setGalleryDisplayMedia(
      $clicked.closest('.gallery'),
      $target,
      $target.prev(),
      $target.next()
    );
  });
}